import { createContext, useContext, useState, ReactNode } from "react";
import { IntlProvider } from "react-intl";
import "dayjs/locale/it";
import en from "./locales/en.json";
import it from "./locales/it.json";

const messages = { en, it } as const;

type Locale = keyof typeof messages;

interface I18nContextProps {
  locale: Locale;
  setLocale: (locale: Locale) => void;
}

const I18nContext = createContext<I18nContextProps | undefined>(undefined);

export function useI18n() {
  const context = useContext(I18nContext);
  if (!context) throw new Error("useI18n must be used within I18nProvider");
  return context;
}

export function I18nProvider({ children }: { children: ReactNode }) {
  const [locale, setLocale] = useState<Locale>("en");

  return (
    <I18nContext.Provider value={{ locale, setLocale }}>
      <IntlProvider locale={locale} messages={messages[locale]}>
        {children}
      </IntlProvider>
    </I18nContext.Provider>
  );
}
